export const SUPPORTED_STATUS_CODES = [
    'surveyAlreadyFinished',
    'surveyClosed',
    'surveyNotFound',
    'surveyPaused',
    'serverDefault',
    'thanks'
] as const;

export type StatusCode = typeof SUPPORTED_STATUS_CODES[number];
